<template>
  <div>
    <ThankYouAlert />

    <WidgetsStat @open-configure-domain="onOpenConfigureDomain" />

    <div class="mb-3">
      <a-alert
          class="exclusive-cname"
          type="info"
          show-icon
      >
         <span slot="message">
           {{ $t('ExclusiveCNAME') }}:
           <strong>{{ cname }}</strong>
           <a-button v-if="isNotTrustyCDN" type="link" @click="handleConfigureCnameClick">
             {{ $t('ConfigureSubscription') }}
           </a-button>
         </span>
      </a-alert>
    </div>
    
    <!--<div>
      <CAlert color="info">
        <p><strong>{{ $t('GenevaAnnouncement') }}</strong></p>
        <span v-html="$t('GenevaAnnouncementDescription')"></span>
      </CAlert>
    </div>-->

    <!--<div v-if="isNotTrustyCDN">
      <CAlert color="warning">
        <p><strong>{{ $t('MaintenanceTitle') }}</strong></p>
        <span v-html="$t('MaintenanceDescription')" />
      </CAlert>
    </div>
    <div v-else>
      <CAlert color="warning">
        <p><strong>{{ $t('TrustyCDNMaintenanceTitle') }}</strong></p>
        <span v-html="$t('TrustyCDNMaintenanceDescription')" />
      </CAlert>
    </div>-->


    <div>
      <div class="d-flex">
        <div>
          <a-popover v-model="showPopoverListFilter" :title="$t('Filter')" trigger="click" placement="right" :overlay-style="{width: 250}">
            <div slot="content" style="width: 265px;">
              <table>
                <tbody>
                <tr>
                  <td>{{ $t('DomainsPerPage') }}</td>
                  <td class="pl-2">
                    <a-select size="small" :default-value="perpage" style="width: 130px"
                              @change="pageSizeChanged">
                      <a-select-option :value="25">
                        25
                      </a-select-option>
                      <a-select-option :value="50">
                        50
                      </a-select-option>
                      <a-select-option :value="100">
                        100
                      </a-select-option>
                      <a-select-option :value="250">
                        250
                      </a-select-option>
                      <a-select-option :value="1000">
                        1000
                      </a-select-option>
                    </a-select>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t('DomainStatus') }}</td>
                  <td class="pl-2">
                    <a-select size="small" default-value="all" style="width: 130px"
                              @change="handleDomainStatusFilter">
                      <a-select-option value="all">
                        {{ $t('all') }}
                      </a-select-option>
                      <a-select-option value="running">
                        {{ $t('Running') }}
                      </a-select-option>
                      <a-select-option value="disabled">
                        {{ $t('Deactivated') }}
                      </a-select-option>
                    </a-select>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t('CertStatus') }}</td>
                  <td class="pl-2">
                    <a-select size="small" default-value="all" style="width: 130px"
                              @change="handleCertStatusFilter">
                      <a-select-option value="all">
                        {{ $t('all') }}
                      </a-select-option>
                      <a-select-option value="https">
                        {{ $t('SSLActive') }}
                      </a-select-option>
                      <a-select-option value="http">
                        {{ $t('SSLInactive') }}
                      </a-select-option>
                      <a-select-option value="force">
                        {{ $t('ForceSSL') }}
                      </a-select-option>
                    </a-select>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t('sort_by') }}</td>
                  <td class="pl-2">
                    <a-select size="small" default-value="newest" style="width: 130px"
                              @change="handleSortByFilter">
                      <a-select-option value="newest">
                        {{ $t('newest_to_oldest') }}
                      </a-select-option>
                      <a-select-option value="oldest">
                        {{ $t('oldest_to_newest') }}
                      </a-select-option>
                      <a-select-option value="domain_ascending">
                        {{ $t('domain_ascending') }}
                      </a-select-option>
                      <a-select-option value="domain_descending">
                        {{ $t('domain_descending') }}
                      </a-select-option>
                    </a-select>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <button type="button" class="popover-list-filter-trigger btn btn-sm">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                   stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z"/>
              </svg>
            </button>
          </a-popover>
        </div>
        <ListActionBar>
          <template v-slot:filters>
            <div class="d-flex w-80">
              <div class="d-flex w-100 align-items-center">
                <div class="searchInput w-75 mr-2">
                  <a-input-search
                      :placeholder="$t('message.KeywordSearch')"
                      size="large"
                      @search="doSearch">
                    <a-button slot="enterButton" icon="search"/>
                  </a-input-search>
                </div>
                <div class="w-75 ml-2 mr-2">
                  <a-button class="ant-btn-lg" @click="visibleModalFindDomain = !visibleModalFindDomain">
                    {{ $t('FindDomain') }}
                  </a-button>
                  <a-modal :visible="visibleModalFindDomain" :title="$t('FindDomain')">
                    <a-textarea rows="25" v-model="findMultiDomain" :placeholder="$t('PlaceholderFindDomain')"
                                allow-clear/>
                    <template #footer>
                      <a-button key="close" @click="visibleModalFindDomain = !visibleModalFindDomain">{{
                          $t('Close')
                        }}
                      </a-button>
                      <a-button key="clear" @click="findMultiDomain = ''">{{ $t('Clear') }}</a-button>
                      <a-button key="submit" type="primary" @click="findBtnClicked = true; fetchRoutes()">{{
                          $t('Find')
                        }}
                      </a-button>
                    </template>
                  </a-modal>
                </div>

                <div>
                  <a-tag v-if="count" color="blue">{{ $t('SearchCount') }} {{ total_rows }}</a-tag>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:action-buttons>
            <div>
              <a-button-group class="batch-edit-button-group mr-2">
                <a-button @click="endSelect" v-if="selectedRows.length" :disabled="listLoading">
                  {{ $t('Cancel') }} {{ selectedRows.length }}
                  <span v-if="selectedRows.length === 1">&nbsp;{{ $t('selection') }}</span>
                  <span v-else>&nbsp;{{ $t('selections') }}</span>
                </a-button>
                <a-button @click="selectAll" :disabled="listLoading || areAllRoutesLoading">
                  {{ $t('SelectAll') }}
                </a-button>
                <a-dropdown-button @click="patchDomain" :disabled="!isBatchEditMode || isBatchOperationInProgress">
                  <a-icon type="edit"/>
                  {{ $t('BatchEdit') }}
                  <a-icon slot="icon" type="down"/>
                  <a-menu slot="overlay" @click="handleExpandedBatchEditButton">
                    <a-menu-item key="clear-cache">
                      {{ $t('ClearCache') }}
                    </a-menu-item>
                    <a-menu-item key="diagnose">
                      {{ $t('domain.Diagnose') }}
                    </a-menu-item>
                    <a-sub-menu key="https" title="HTTPS">
                      <a-menu-item key="enable-https">{{ $t('Enable') }}</a-menu-item>
                      <a-menu-item key="enable-force-https">{{ $t('EnableForceHTTPS') }}</a-menu-item>
                      <a-menu-item key="disable-force-https">{{ $t('DisableForceHTTPS') }}</a-menu-item>
                    </a-sub-menu>
                    <a-sub-menu key="status" :title="$t('domain.Status')">
                      <a-menu-item key="status-restore">{{ $t('Restore') }}</a-menu-item>
                      <a-menu-item key="status-deactivate">{{ $t('Deactivate') }}</a-menu-item>
                      <a-menu-item key="status-delete" :disabled="loadingRemove">
                        <a-spin v-if="loadingRemove" size="small"/>
                        {{ $t('Delete') }}
                      </a-menu-item>
                    </a-sub-menu>
                    <a-menu-item key="download">
                      {{ $t('Download') }}
                    </a-menu-item>
                  </a-menu>
                </a-dropdown-button>
              </a-button-group>
              <a-dropdown-button @click="addDomain" class="create-button-group">
                <a-icon type="plus-circle"/>
                {{ $t('domain.AddDomain') }}
                <a-icon slot="icon" type="down"/>
                <a-menu slot="overlay" @click="handleExpandedCreateButton">
                  <a-menu-item key="import">
                    {{ $t('domain.Import') }}
                  </a-menu-item>
                  <a-menu-item key="create-rules">
                    Create rules
                  </a-menu-item>
                </a-menu>
              </a-dropdown-button>
            </div>
          </template>
        </ListActionBar>
      </div>
      <div class="my-2">
        <p class="mb-0" :class="{'opacity-0': (selectedRows.length === 0)}">
          {{ $t('SelectedDomains') }} {{ selectedRows.length }}
        </p>
      </div>
      <div class="domain-list-container mb-2">
        <DomainList :fetching-domains="listLoading"
                    :domains="routeList"
                    :selected-row-key-map="selectedRowKeyMap"
                    :is-free-cname="isFreeCname"
                    :current-page="page"
                    :domain-per-page="perpage"
                    :total-domains-to-paginate="total_items"
                    @pageChanged="pageChanged"
                    @select="handleDomainSelect"/>
      </div>
    </div>

    <EditDomain :source-route="selectedDomain"
                @refresh="refresh"
                :editShow="activeModal === modalFlags.EDIT"
                @hide="activeModal = null"
                @onStopConfirmModal="attachDomainWsHandler"/>

    <ApplyRule :source-route="selectedDomain"
               @refresh="refresh"
               :domain="selectedDomain"
               :editShow="activeModal === modalFlags.APPLY_RULE"
               @hide="activeModal = null"/>

    <ConfigureCname
        :show="activeModal === modalFlags.CONFIGURE_CNAME"
        :default-tab="activeTab"
        @hide="closeConfigureCnameModal"
    />

    <PatchDomain ref="patchDomainModal"
                 :patchDomain="selectedDomain"
                 :domains="selectedRows"
                 :domain_ws="domain_ws"
                 @hide="endSelect"
                 @shadow-domain-delete="refresh"
                 :patchShow.sync="patchModal"
                 id="patchModal"/>

    <SslConfig :domain="selectedDomain"
               :issue_ws="issue_ws"
               :isVisible="activeModal === modalFlags.SSL_CONFIG"
               :sslLoader="sslLoader"
               @hide="handleHideSslConfig"
               @refresh="refresh"/>

    <ClearCache v-if="clearCacheModal"
                :clearCacheModal.sync="clearCacheModal"
                :clearCacheTitle="clearCacheTitle"/>

    <Diagnose :domain="selectedDomain"
              v-if="selectedDomain"
              :diagnoseModal.sync="diagnoseModal"
              :diagnoseTitle="diagnoseTitle"/>

    <CModal :title="$t('Diagnose')"
            color="warning"
            :show.sync="showSummaryDiagnoseModal">
      <BatchDiagnose :domains="selectedRows"
                     :diagnose="showSummaryDiagnoseModal"
                     v-if="showSummaryDiagnoseModal"/>
    </CModal>

    <CModal
        :title="$t('cluster.UpgradeServiceArea')"
        color="warning"
        :show.sync="clusterUpgradeModal"
        v-if="selectedDomain && clusterUpgradeModal"
        id="clusterUpgradeModal"
    >
      <ClusterUpgrade :domain="selectedDomain" @hide="clusterUpgradeModal=false"/>
      <template slot="footer-wrapper">
        <footer class="modal-footer" style="justify-content: space-between;">&nbsp;</footer>
      </template>
    </CModal>

    <CModal :title="$t('message.DomainActivationConfirmation')" color="warning" :show.sync="showConfirmActivateModal">
      <div>
        <CAlert color="warning">
          <p><strong>{{ $t("Domain") }}： {{ selectedDomain ? selectedDomain.name : '' }}</strong></p>
          <p>{{ $t('message.domain_for_activation_deploy') }}</p>
        </CAlert>
      </div>
      <template slot="footer-wrapper">
        <footer class="modal-footer">
          <CButton @click="closeActivateDomainModal">{{ $t('Cancel') }}</CButton>
          <CButton
              type="submit"
              color="primary"
              size="sm"
              @click="activateDomain(selectedDomain)"
          >
            <span>{{ $t('proceed') }}</span>
          </CButton>
        </footer>
      </template>
    </CModal>

    <a-modal :visible="showNewUiFeedbackDialog" :title="$t('message.NewUiFeedbackModalTitle')"
             @cancel="showNewUiFeedbackDialog = false">
      {{ $t('message.AskingFeedback') }}
      <template #footer>
        <a-button key="back" @click="handleGoToOldDomainUI">{{ $t('message.NoThanks') }}</a-button>
        <a-button key="submit" type="primary" @click="handleGiveFeedback">
          <span v-if="showThankYou">{{ $t('message.SwitchToOldUI') }}</span>
          <span v-else>{{ $t('message.SureGiveFeedback') }}</span>
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import "driver.js/dist/driver.min.css"
import axios from "@/plugins/axios.js";
import Driver from "driver.js"
import Fuse from 'fuse.js';
import {Modal} from 'ant-design-vue';
import {mapGetters} from "vuex";

import {Websocket} from "@/plugins/websocket.js";
import EditDomain from "./EditDomain/EditDomain";
import ApplyRule from "./EditDomain/ApplyRule";
import PatchDomain from "./PatchDomain";
import SslConfig from "./SslConfig";
import ClearCache from "./ClearCache.vue";
import Diagnose from "./Diagnose.vue";
import ClusterUpgrade from "./ClusterUpgrade.vue";
import WidgetsStat from '../widgets/WidgetsStat';
import ThankYouAlert from './ThankYouAlert.vue';

import {bus} from '@/main';
import {EventBus, Events} from "@/plugins/event-bus.js";
import getDefaultDomainConfig from '@/utilities/getDefaultDomainConfig';
import {
  findDomains,
} from '@/utilities/api';
import BatchDiagnose from '@/views/domain/BatchDiagnose';
import ListActionBar from '@/views/domain/ListActionBar';
import {isArray} from 'lodash';
import {DomainAction, CertAction} from '@/utilities/websocket';
import {ExportDomainMixin, COLUMN_KEYS} from '@/mixins/ExportDomainMixin';
import {BusListenersMixin} from '@/mixins/BusListenersMixin';
import { LIMIT_BATCH_DELETE, LIMIT_BATCH_DEACTIVATE, LIMIT_BATCH_RESTORE, LIMIT_BATCH_CLEAR_CACHE, LIMIT_BATCH_CLEAR_CUSTOM_CACHE, LIMIT_BATCH_FORCE_HTTPS, LIMIT_BATCH_ENABLE_HTTPS } from '@/utilities/batch';
import {WebSocketBatchQueue} from '@/utilities/WebSocketBatchQueue';
import {
  EVENT_BUS_EVENTS,
  MIXED_VALUE,
  TAG_NAMES,
  PLUGIN_NAMES,
  TASK_NAMES,
  CONFIGURE_CNAME_TABS,
  REFRESH_DELAY_BY_PAGE_SIZE,
  SHOW_DOMAIN_NOTES_STORAGE_KEY,
  MODAL_FLAGS
} from '@/utilities/constants';
import {makeRoutes} from '@/models/RouteFactory';
import {Route} from '@/models/Route';
import {FETCH_COIN_SUPPORT_IF_EMPTY} from '@/store/types';
import ConfigureCname from '@/views/domain/EditDomain/ConfigureCname';
import DomainList from '@/views/domain/DomainList.vue';
import router from '@/router';


const getRefreshDelay = (perpage) => REFRESH_DELAY_BY_PAGE_SIZE[perpage] ?? 3000;
let lastExecution = 0;

// AC-2010: localStorage key for the domain selection of a batch interrupted by
// navigation, so it can be restored (no re-selection) when the user returns.
const INTERRUPTED_BATCH_KEY = 'gaius:domain:interruptedBatchSelection';

let SHOW_DOMAIN_NOTES_DEFAULT = false;
if (window.localStorage) {
  SHOW_DOMAIN_NOTES_DEFAULT = localStorage.getItem(SHOW_DOMAIN_NOTES_STORAGE_KEY) === "true";
}

export default {
  name: "List",
  mixins: [ExportDomainMixin, BusListenersMixin],
  components: {
    DomainList,
    BatchDiagnose,
    EditDomain,
    ApplyRule,
    PatchDomain,
    SslConfig,
    ClearCache,
    Diagnose,
    ClusterUpgrade,
    WidgetsStat,
    ThankYouAlert,
    ConfigureCname,
    ListActionBar,
  },
  watch: {
    editModal() {
      if (!this.editModal) {
        this.attachDomainWsHandler();
      }
    },
    showDomainNotes(value) {
      if (window.localStorage) {
        localStorage.setItem(SHOW_DOMAIN_NOTES_STORAGE_KEY, value);
      }
    },
  },
  computed: {
    ...mapGetters(["isNotTrustyCDN"]),
    selectedRows: function () {
      return this.routeList.filter((r) => Boolean(this.selectedRowKeyMap[this.getDomainRowKey(r)]));
    },
    isBatchEditMode: function () {
      return this.selectedRows.length > 0;
    },
    isBatchOperationInProgress: function () {
      const hasActivity = (q) => (q?.inFlightCount || 0) + (q?.pendingCount || 0) > 0;
      return (
        hasActivity(this.deactivateQueue) ||
        hasActivity(this.restoreQueue) ||
        hasActivity(this.deleteQueue) ||
        hasActivity(this.clearCacheQueue) ||
        hasActivity(this.clearCustomCacheQueue) ||
        hasActivity(this.enableHttpsQueue) ||
        hasActivity(this.forceHttpsEnableQueue) ||
        hasActivity(this.forceHttpsDisableQueue)
      );
    },
    // AC-2010: total in-flight + queued domains across all batch queues.
    batchPendingCount: function () {
      const n = (q) => (q?.inFlightCount || 0) + (q?.pendingCount || 0);
      return n(this.deactivateQueue) + n(this.restoreQueue) + n(this.deleteQueue)
        + n(this.clearCacheQueue) + n(this.clearCustomCacheQueue) + n(this.enableHttpsQueue)
        + n(this.forceHttpsEnableQueue) + n(this.forceHttpsDisableQueue);
    },
    isBatchDeleteInProgress: function () {
      return this.$store.getters.isAnyDomainLoadingForAction(DomainAction.DOMAIN_DELETE);
    },
    areAllRoutesLoading: function () {
      return this.routeList.every((r) => this.$store.getters.isDomainLoading(r.getId()));
    },
    isFreeCname: function () {
      const subscriptions = this.$store.state.subscriptions;
      for (let s of subscriptions) {
        if (!s.plan) {
          return true;
        }
        if (s && s.plan && s.plan.name == "Free") {
          return true;
        }
      }

      return false;
    },
    cname: function () {
      return this.$store.getters.cname;
    },
    issue_ws: {
      get() {
        return this.$store.state.websocket.issue_ws
      },
      set(value) {
        this.$store.state.websocket.issue_ws = value
      }
    },
    shadow_ws: {
      get() {
        return this.$store.state.websocket.shadow_ws;
      },
      set(value) {
        this.$store.state.websocket.shadow_ws = value
      }
    },
    domain_ws: {
      get() {
        return this.$store.state.websocket.domain_ws;
      },
      set(value) {
        this.$store.state.websocket.domain_ws = value;
      }
    },
    clearCacheTitle: function () {
      var title = this.$t('domain.ClearCache');
      return title;
    },
    diagnoseTitle: function () {
      var title = this.$t('domain.DomainStatusCheck');
      if (this.selectedDomain) {
        title += " [" + this.selectedDomain.getMainHost() + "]"
      }
      return title
    },
    routeList: function () {
      if (this.searchTerm.length) {
        return this.searchResult;
      }

      return this.routes.filter(item => {
        const upstream = item._data.upstream || {};
        if (Object.hasOwn(upstream, 'targets')) {
          if (upstream.targets.length) {
            return item;
          }
        } else {
          for (let plugin of (item._data.plugins || [])) {
            if (plugin.name === 'gaius-redirect') {
              return item;
            }
          }
        }
      });
    },
    routeMap: function () {
      const map = {};
      for (let r of this.routes) {
        map[r.getId()] = r;
      }

      return map;
    },
    searchData: function () {
      return this.routes.map((m) => {
        return {
          routeId: m.getId(),
          hosts: m.getHosts(),
          serviceHost: m.getServiceHost()
        }
      });
    },
    searchIndex: function () {
      return Fuse.createIndex(['hosts', 'serviceHost'], this.searchData);
    },
  },

  data() {
    return {
      selectedRowKeyMap: Object.create(null),
      selectedSearchDomains: [],
      domainsPage: 1,
      storedDomainSearch: null,
      routes: [],
      driver: null,
      searchTerm: "",
      searchResult: [],
      total_rows: 0,
      total_pages: 10,
      total_items: 0,
      current_page_offset: null,
      next_page_offset: null,
      previous_page_offset: null,
      columnFilter: {
        external: true, lazy: true
      },
      dg: null,
      clearCacheModal: false,
      diagnoseModal: false,
      showSummaryDiagnoseModal: false,
      diagnoseKey: 0,
      show: false,
      listLoading: false,
      queryParams: {},
      page: 1,
      perpage: 25,
      editModal: false,
      patchModal: false,
      sslModal: false,
      clusterUpgradeModal: false,
      defaultDomain: this.getDefaultDomain(),
      selectedDomain: new Route(),
      domainSubscription: {},
      showConfirmActivateModal: false,
      queueDomainCleanCache: [],
      onProgressDomainCleanCache: [],
      showDomainNotes: SHOW_DOMAIN_NOTES_DEFAULT,
      activeModal: null,
      activeTab: "1",
      modalFlags: MODAL_FLAGS,
      sslLoader: false,
      certStatus: null,
      domainStatus: null,
      domainQ: null,
      domainQ1: null,
      count: false,
      loadingRemove: false,
      showPopoverListFilter: false,
      showNewUiFeedbackDialog: false,
      showThankYou: false,
      findBtnClicked: false,
      enableHttpsPendingByDomainId: Object.create(null),
      enableHttpsHasErrorByDomainId: Object.create(null),
      forceHttpsPendingByDomainId: Object.create(null),
      forceHttpsHasErrorByDomainId: Object.create(null),
      sortBy: 'newest',
    };
  },

  props: {
    caption: {
      type: String,
      default: 'domain.DomainList'
    },
    group: Object,
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    fixed: Boolean,
    dark: Boolean,
  },

  created() {
    this.$store.dispatch(FETCH_COIN_SUPPORT_IF_EMPTY);

    this.subscribeBus(bus, 'updateDomainList', () => this.refresh());
    this.subscribeBus(EventBus, 'clearFullCacheEvent', () => this.patchCleancache());
    this.subscribeBus(EventBus, 'clearCustomCacheEvent', (targets) => this.patchCleanCustomcache(targets));
  },

  async mounted() {
    await this.openWs();
    this.initDeleteQueue();
    this.initDeactivateQueue();
    this.initRestoreQueue();
    this.initClearCacheQueue();
    this.initClearCustomCacheQueue();
    this.initForceHttpsQueues();
    this.initEnableHttpsQueue();
    this.refresh();

    this.listenEvent();
    this.restoreInterruptedBatchSelection();
  },
  beforeDestroy() {
    this.closeWs();
  },
  // AC-2010: warn before navigating away mid-batch (the queue can't run while this
  // route is gone). Confirm => persist the selection so it's restored on return.
  beforeRouteLeave(to, from, next) {
    if (!this.isBatchOperationInProgress) {
      next();
      return;
    }
    Modal.confirm({
      title: this.$t('message.batch_leave_title'),
      content: this.$t('message.batch_leave_content', { count: this.batchPendingCount }),
      okText: this.$t('message.batch_leave_ok'),
      okType: 'danger',
      cancelText: this.$t('message.batch_leave_cancel'),
      onOk: () => {
        this.persistInterruptedBatchSelection();
        next();
      },
      onCancel: () => next(false),
    });
  },
  methods: {
    handleGiveFeedback() {
      if (this.showThankYou) {
        this.handleGoToOldDomainUI();
      } else {
        this.showThankYou = true;
      
        let formLink = 'https://forms.gle/bgTKyFaLjidUne9JA';
        if (this.$i18n.locale === 'zh-CN') {
          formLink = 'https://forms.gle/PACB5Mz1BuWz7vtE7';
        }
        
        window.open(formLink, '_blank', 'noopener,noreferrer');
      }
    },
    updateSelectedRows(rows) {
      const nextMap = Object.create(null);
      (rows || []).forEach((r) => {
        nextMap[this.getDomainRowKey(r)] = true;
      });
      this.selectedRowKeyMap = nextMap;
    },
    getDomainStatus(row) {
      return (row.getStatus && row.getStatus()) || row._data?.status || '';
    },
    /** Update domain status in list. Uses display labels: 'Deactivated' | 'Running'. */
    updateDomainStatus(domain, status) {
      if (!domain || !domain._data) return;
      this.$set(domain._data, 'status', status);
    },
    getDomainRowKey(domain) {
      // Must match the row-key used by DomainList (and be stable across renders).
      return domain && domain.getMainHost ? domain.getMainHost() : (domain && domain.name) || '';
    },
    getDomainId(domain) {
      return (domain && (domain.getId ? domain.getId() : (domain._data && domain._data.id))) || domain?.id;
    },
    setDomainActionLoading(domain, actionId, loading = true) {
      const domainId = this.getDomainId(domain);
      this.$store.commit('setDomainActionLoading', { domainId, actionId, loading });
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    pageChanged(page) {
      this.page = page;
      this.refresh();
    },
    pageSizeChanged(pageSize) {
      this.page = 1;
      this.perpage = pageSize;
      this.refresh();
    },
    showDomainTooltip(domain, content, type, delay = 5000) {
      if (!domain) return;
      this.$set(domain, '_message', {
        content: content,
        show: true,
        type: type
      });
      setTimeout(() => {
        domain._message.show = false;
        domain._message = {};
        if (Object.hasOwn(domain, 'last_entry') && domain["last_entry"] == true) {
          window.location.reload();
        }
      }, delay);
    },
    async openWs() {
      this.domain_ws = new Websocket(`domain/`);
      this.issue_ws = new Websocket(`certificate/`, process.env.VUE_APP_CERT_WSS);
      this.attachDomainWsHandler();
      this.attachIssueWsHandler();
    },
    /** Returns matcher for WebSocketBatchQueue.completeOne. */
    matchQueueItemByDomain(domain) {
      if (!domain) return () => true;
      const targetId = domain.getId ? domain.getId() : domain.id;
      return (item) => {
        const itemId = item && (item.getId ? item.getId() : item.id);
        return itemId === targetId;
      };
    },
    /** Match queue item by domain name string (e.g. from cert WS response data.domain). */
    matchQueueItemByDomainName(domainName) {
      if (!domainName) return () => true;
      const domain = this.getDomainFromRouteList({ domain_name: domainName });
      return this.matchQueueItemByDomain(domain);
    },
    /** AC-2010: persist the in-progress batch selection (after the leave guard is
     * confirmed) so it isn't lost; restored on return so the user needn't reselect. */
    persistInterruptedBatchSelection() {
      try {
        if (!window.localStorage) return;
        const keys = Object.keys(this.selectedRowKeyMap).filter((k) => this.selectedRowKeyMap[k]);
        if (keys.length) localStorage.setItem(INTERRUPTED_BATCH_KEY, JSON.stringify(keys));
      } catch (e) { /* best-effort: persistence must never block navigation */ }
    },
    /** AC-2010: restore a selection saved by persistInterruptedBatchSelection (one-shot). */
    restoreInterruptedBatchSelection() {
      try {
        if (!window.localStorage) return;
        const raw = localStorage.getItem(INTERRUPTED_BATCH_KEY);
        if (!raw) return;
        localStorage.removeItem(INTERRUPTED_BATCH_KEY);
        const keys = JSON.parse(raw);
        if (!Array.isArray(keys) || !keys.length) return;
        const map = Object.create(null);
        keys.forEach((k) => { map[k] = true; });
        this.selectedRowKeyMap = map;
        this.flash(this.$t('message.batch_selection_restored', { count: keys.length }), 'info', { timeout: 5000 });
      } catch (e) { /* best-effort */ }
    },
    /**
     * Handle PAUSE_RESTORE success/error for deactivate or restore queue.
     * @param {Object} result - WS result
     * @param {Object|null} domain - Resolved domain (null when response lacks per-domain info)
     * @param {string} status - 'Deactivated' or 'Running' (display label)
     * @param {WebSocketBatchQueue} queue - deactivateQueue or restoreQueue
     * @returns {boolean} true if handled
     */
    handlePauseRestoreResponse(result, domain, status, queue) {
      if (!queue?.inFlightCount) return false;
      if (!result.data?.error) {
        if (domain) {
          this.updateDomainStatus(domain, status);
          queue.completeOne(this.matchQueueItemByDomain(domain));
        } else {
          queue.inFlightItems.forEach((r) => this.updateDomainStatus(r, status));
          queue.completeAll();
        }
      } else {
        queue.completeOne(domain ? this.matchQueueItemByDomain(domain) : undefined);
      }
      return true;
    },
    initDeleteQueue() {
      this.deleteQueue = new WebSocketBatchQueue({
        concurrency: LIMIT_BATCH_DELETE,
        onSend: (rows) => {
          rows.forEach((row) => {
            this.setDomainActionLoading(row, DomainAction.DOMAIN_DELETE);
            this.showDomainTooltip(row, this.$i18n.t('DeployActionDelete'), 'success');
          });
          this.sendDeleteBatch(rows);
        },
        onCompleteOne: (row) => {
          this.setDomainActionLoading(row, DomainAction.DOMAIN_DELETE, false);
        },
        onDrain: () => {
          if (this.$refs.patchDomainModal) this.$refs.patchDomainModal.processing = false;
          this.page = 1;
          this.refresh();
          bus.$emit('updateDomainStat');
          bus.$emit('updateQuota');
          this.endSelect();
        },
      });
    },
    createActionQueue(action, tooltipKey, concurrency) {
      return new WebSocketBatchQueue({
        concurrency,
        onSend: (rows) => {
          rows.forEach((row) => {
            this.setDomainActionLoading(row, action);
            this.showDomainTooltip(row, this.$i18n.t(tooltipKey), 'success');
          });
          this.sendDeploy(action, rows);
        },
        onCompleteOne: (row) => {
          this.setDomainActionLoading(row, action, false);
        },
        onDrain: () => {
          if (this.$refs.patchDomainModal) this.$refs.patchDomainModal.processing = false;
          this.page = 1;
          this.refresh();
          this.endSelect();
        },
      });
    },
    initDeactivateQueue() {
      this.deactivateQueue = new WebSocketBatchQueue({
        concurrency: LIMIT_BATCH_DEACTIVATE,
        onSend: (rows) => {
          rows.forEach((row) => {
            this.setDomainActionLoading(row, DomainAction.DOMAIN_DEACTIVATE);
            this.showDomainTooltip(row, this.$i18n.t('DeployActionDeactivate'), 'success');
          });
          this.domain_ws.sendMessage(DomainAction.PAUSE_RESTORE_DOMAIN, {
            routeIds: rows.map((r) => r._data.id),
            paused: true,
            row: { paused: true },
          });
        },
        onCompleteOne: (row) => {
          this.setDomainActionLoading(row, DomainAction.DOMAIN_DEACTIVATE, false);
        },
        onDrain: () => {
          this.page = 1;
          this.refresh();
          this.endSelect();
          bus.$emit('updateDomainStat');
          bus.$emit('updateQuota');
        },
      });
    },
    initRestoreQueue() {
      this.restoreQueue = new WebSocketBatchQueue({
        concurrency: LIMIT_BATCH_RESTORE,
        onSend: (rows) => {
          rows.forEach((row) => {
            this.setDomainActionLoading(row, DomainAction.DOMAIN_RESUME);
            this.showDomainTooltip(row, this.$i18n.t('DeployActionResume'), 'success');
          });
          this.domain_ws.sendMessage(DomainAction.PAUSE_RESTORE_DOMAIN, {
            routeIds: rows.map((r) => r._data.id),
            paused: false,
            row: { paused: false },
          });
        },
        onCompleteOne: (row) => {
          this.setDomainActionLoading(row, DomainAction.DOMAIN_RESUME, false);
        },
        onDrain: () => {
          this.page = 1;
          this.refresh();
          this.endSelect();
          bus.$emit('updateDomainStat');
          bus.$emit('updateQuota');
        },
      });
    },
    initClearCacheQueue() {
      this.clearCacheQueue = new WebSocketBatchQueue({
        concurrency: LIMIT_BATCH_CLEAR_CACHE,
        onSend: (rows) => {
          rows.forEach((row) => {
            this.setDomainActionLoading(row, DomainAction.CLEAR_CACHE);
            this.showDomainTooltip(row, this.$i18n.t('ClearCacheActionRunning'), 'success');
          });
          this.domain_ws.sendMessage(DomainAction.CLEAR_CACHE, rows.map((r) => r._data.service.id));
        },
        onCompleteOne: (row) => {
          this.setDomainActionLoading(row, DomainAction.CLEAR_CACHE, false);
        },
        onDrain: () => {
          this.page = 1;
          this.refresh();
          this.endSelect();
          this.flash(this.$t('ClearCacheActionSuccessful'), 'success', { timeout: 8000 });
        },
      });
    },
    initClearCustomCacheQueue() {
      this.clearCustomCacheQueue = new WebSocketBatchQueue({
        concurrency: LIMIT_BATCH_CLEAR_CUSTOM_CACHE,
        onSend: (chunks) => {
          chunks.forEach((chunk) => {
            this.domain_ws.sendMessage(DomainAction.CLEAR_CUSTOM_CACHE, chunk);
          });
        },
        onDrain: () => {
          if (this.$refs.patchDomainModal) this.$refs.patchDomainModal.processing = false;
          this.page = 1;
          this.refresh();
          this.endSelect();
          this.flash(this.$t('ClearCacheActionSuccessful'), 'success', { timeout: 8000 });
        },
      });
    },
    initForceHttpsQueues() {
      const createForceHttpsQueue = (enabled) => {
        const tooltipKey = enabled ? 'message.BatchForceSSLEnabled' : 'message.BatchForceSSLDisabled';
        return new WebSocketBatchQueue({
          concurrency: LIMIT_BATCH_FORCE_HTTPS,
          onSend: (rows) => {
            rows.forEach((row) => {
              const domainId = String(this.getDomainId(row));
              this.$set(this.forceHttpsPendingByDomainId, domainId, this.getPendingHosts(row));
              this.$set(this.forceHttpsHasErrorByDomainId, domainId, false);
              this.setDomainActionLoading(row, DomainAction.FORCE_HTTPS);
              this.showDomainTooltip(row, this.$i18n.t(tooltipKey), 'success');
            });
            this.domain_ws.sendMessage(DomainAction.FORCE_HTTPS, {
              routeIds: rows.map((r) => r._data.id),
              enabled,
            });
          },
          onCompleteOne: (row) => {
            const domainId = String(this.getDomainId(row));
            this.setDomainActionLoading(row, DomainAction.FORCE_HTTPS, false);
            this.$delete(this.forceHttpsHasErrorByDomainId, domainId);
          },
          onDrain: () => {
            this.forceHttpsPendingByDomainId = Object.create(null);
            this.forceHttpsHasErrorByDomainId = Object.create(null);
            this.page = 1;
            this.refresh();
            this.endSelect();
            EventBus.$emit(EVENT_BUS_EVENTS.TASK_SCHEDULED, {
              task: TASK_NAMES.FORCE_HTTPS,
              options: { enabled },
            });
          },
        });
      };
      this.forceHttpsEnableQueue = createForceHttpsQueue(true);
      this.forceHttpsDisableQueue = createForceHttpsQueue(false);
    },
    initEnableHttpsQueue() {
      this.enableHttpsQueue = new WebSocketBatchQueue({
        concurrency: LIMIT_BATCH_ENABLE_HTTPS,
        onSend: (rows) => {
          rows.forEach((row) => {
            const domainId = String(this.getDomainId(row));
            this.$set(this.enableHttpsPendingByDomainId, domainId, this.getPendingHosts(row));
            this.$set(this.enableHttpsHasErrorByDomainId, domainId, false);
            this.setDomainActionLoading(row, DomainAction.ENABLE_HTTPS);
            this.showDomainTooltip(row, this.$i18n.t('EnableHTTPS'), 'success');
          });
          this.issue_ws.sendMessage(DomainAction.ENABLE_HTTPS, {
            routeIds: rows.map((r) => r._data.id),
          });
        },
        onCompleteOne: (row) => {
          const domainId = String(this.getDomainId(row));
          const hasError = Boolean(this.enableHttpsHasErrorByDomainId[domainId]);
          this.setDomainActionLoading(row, DomainAction.ENABLE_HTTPS, false);
          if (!hasError) {
            this.updateDomainCertState(row, true);
          }
          this.$delete(this.enableHttpsHasErrorByDomainId, domainId);
        },
        onDrain: () => {
          this.sslLoader = false;
          this.enableHttpsPendingByDomainId = Object.create(null);
          this.enableHttpsHasErrorByDomainId = Object.create(null);
          this.page = 1;
          this.refresh();
          this.endSelect();
          EventBus.$emit(EVENT_BUS_EVENTS.TASK_SCHEDULED, {
            task: TASK_NAMES.ENABLE_HTTPS,
            options: {},
          });
        },
      });
    },
    sendDeleteBatch(rows) {
      const route_ids = rows
        .map((row) => {
          const cnameTag = row._data.tags && row._data.tags.find((t) => t.includes('cname'));
          if (!cnameTag) return null;
          return {
            route_id: row._data.id,
            cname: cnameTag.split('"')[1],
            row: { name: row._data.domain_name.replace(/-/g, '.'), hit_broadcast: true },
            domain: row,
          };
        })
        .filter(Boolean);
      if (route_ids.length === 0) return;
      this.domain_ws.sendMessage(DomainAction.DOMAIN_DELETE, { route_ids });
    },
    /**
     * This is a helper function to enable the green lock icon in the domain card
     * after the batch enable cert operation is completed for a domain to make ux more better.
     * 
     * @param domain Domain row object
     * @param hasCert Whether the domain has a certificate
     */
    updateDomainCertState(domain, hasCert) {
      if (!domain || !domain._data) return;
      this.$set(domain._data, 'has_cert', hasCert);
    },
    getDomainFromRouteList(domainData) {
      if (!domainData || typeof domainData !== 'object') return null;

      // Prefer stable identifiers first.
      const id = domainData.id;
      if (id) {
        const byId = this.routeList.find(d => d.getId && d.getId() === id);
        if (byId) return byId;
      }

      // WS payloads use `hosts` and `domain_name`; some older callers may pass `name`.
      const rawName = domainData?.domain_name || domainData?.name || domainData?._data?.domain_name || '';
      const mainHost =
        (Array.isArray(domainData.hosts) && domainData.hosts[0]) ||
        domainData.host ||
        '';

      if (mainHost) {
        const byHost = this.routeList.find(d => d.getMainHost && d.getMainHost() === mainHost);
        if (byHost) return byHost;
      }

      if (rawName) {
        const byDomainName = this.routeList.find(d => d._data && d._data.domain_name === rawName);
        if (byDomainName) return byDomainName;

        const normalized = rawName.replaceAll('.', '-').replaceAll('*', 'all');
        const byNormalized = this.routeList.find(d => d._data && d._data.domain_name === normalized);
        if (byNormalized) return byNormalized;
      }

      return null;
    },
    /** Flash error and complete queue (used when batch WS returns error). */
    flashErrorAndCompleteQueue(queue, errorMsg) {
      if (errorMsg) this.flash(errorMsg, 'danger', { timeout: 8000 });
      queue?.completeAll();
    },
    /** Returns the in-flight Force HTTPS queue, or null. */
    getActiveForceHttpsQueue() {
      if (this.forceHttpsEnableQueue?.inFlightCount > 0) return this.forceHttpsEnableQueue;
      if (this.forceHttpsDisableQueue?.inFlightCount > 0) return this.forceHttpsDisableQueue;
      return null;
    },
    getForceHttpsStateByQueue(queue) {
      if (!queue) return null;
      if (queue === this.forceHttpsEnableQueue) {
        return {
          pendingMapKey: 'forceHttpsPendingByDomainId',
          errorMapKey: 'forceHttpsHasErrorByDomainId',
          actionId: DomainAction.FORCE_HTTPS,
        };
      }
      if (queue === this.forceHttpsDisableQueue) {
        return {
          pendingMapKey: 'forceHttpsPendingByDomainId',
          errorMapKey: 'forceHttpsHasErrorByDomainId',
          actionId: DomainAction.FORCE_HTTPS,
        };
      }
      return null;
    },
    handleDomainWsError(result, domain) {
      if (!Object.hasOwn(result.data, 'error') || result.action === DomainAction.DOMAIN_UPDATES) return false;
      const err = result.data.error;
      const { action } = result;

      const getQueueForError = () => {
        if (action === DomainAction.CLEAR_CACHE && this.clearCacheQueue?.inFlightCount > 0) return this.clearCacheQueue;
        if (action === DomainAction.CLEAR_CUSTOM_CACHE && this.clearCustomCacheQueue?.inFlightCount > 0) return this.clearCustomCacheQueue;
        if (action === DomainAction.DOMAIN_DELETE && this.deleteQueue?.inFlightCount > 0 && !domain) return this.deleteQueue;
        if (action === DomainAction.PAUSE_RESTORE_DOMAIN && this.deactivateQueue?.inFlightCount > 0 && !domain) return this.deactivateQueue;
        if (action === DomainAction.PAUSE_RESTORE_DOMAIN && this.restoreQueue?.inFlightCount > 0 && !domain) return this.restoreQueue;
        return null;
      };
      const queue = getQueueForError();
      if (queue) {
        this.flashErrorAndCompleteQueue(queue, err);
        return true;
      }

      if (domain) {
        this.showDomainTooltip(domain, err, 'danger', 8000);
        if (action === DomainAction.DOMAIN_DELETE && this.deleteQueue?.inFlightCount > 0) {
          this.setDomainActionLoading(domain, DomainAction.DOMAIN_DELETE, false);
          this.deleteQueue.completeOne(this.matchQueueItemByDomain(domain));
        } else if (action === DomainAction.PAUSE_RESTORE_DOMAIN && this.deactivateQueue?.inFlightCount > 0) {
          this.deactivateQueue.completeOne(this.matchQueueItemByDomain(domain));
        } else if (action === DomainAction.PAUSE_RESTORE_DOMAIN && this.restoreQueue?.inFlightCount > 0) {
          this.restoreQueue.completeOne(this.matchQueueItemByDomain(domain));
        }
        return true;
      }
      return false;
    },
    attachDomainWsHandler() {
      this.domain_ws.onMessage = (event, result) => {
        if (!result || typeof result !== 'object' || !result?.data) return;

        let domain = null;
        if (result.data.domain) {
          domain = this.getDomainFromRouteList(result.data.domain);
          if (Object.hasOwn(result.data.domain, 'last_entry') && domain) {
            domain["last_entry"] = result.data.domain["last_entry"];
          }
        }
        if (!domain && result.data?.row?.name) {
          domain = this.getDomainFromRouteList({ name: result.data.row.name }) ?? this.routeList.find((r) => r.getMainHost?.() === result.data.row.name);
        }
        if (!domain && (result.data?.row?.id ?? result.data?.route_id)) {
          domain = this.getDomainFromRouteList({ id: result.data.row?.id ?? result.data.route_id });
        }

        if (this.handleDomainWsError(result, domain)) return;

        const actionsToAvoidFlashing = [
          DomainAction.FORCE_HTTPS
        ]
        const resultAction = result.action;
        if (result.data.message && !actionsToAvoidFlashing.includes(resultAction)) this.flash(result.data.message, 'success', { timeout: 5000 });

        const handlers = {
          [DomainAction.FORCE_HTTPS]: () => {
            const queue = this.getActiveForceHttpsQueue();
            if (queue) {
              if (result?.data?.error) this.flash(result.data.error, 'danger', { timeout: 8000 });
              return;
            }
          },
          [DomainAction.CLEAR_CACHE]: () => {
            if (this.clearCacheQueue?.inFlightCount > 0) this.clearCacheQueue.completeAll();
          },
          [DomainAction.DOMAIN_DEACTIVATE]: () => {
            if (result.data.dp?.success && domain) this.showDomainTooltip(domain, this.$i18n.t('DeactivateActionSuccessful'), 'success', 8000);
          },
          [DomainAction.DOMAIN_RESUME]: () => {
            if (result.data.dp?.success && domain) this.showDomainTooltip(domain, this.$i18n.t('ResumeActionSuccessful'), 'success', 8000);
          },
          [DomainAction.DOMAIN_DELETE]: () => {
            if (!result.data?.row?.name) return;
            const rowName = result.data.row.name;
            const delDomain = this.getDomainFromRouteList({ name: rowName }) ?? this.routeList.find((r) => r.getMainHost?.() === rowName);
            if (delDomain) {
              this.setDomainActionLoading(delDomain, DomainAction.DOMAIN_DELETE, false);
              this.routes = this.routes.filter((r) => r.getId() !== delDomain.getId());
            }
            if (this.deleteQueue?.inFlightCount > 0) {
              this.deleteQueue.completeOne(delDomain ? this.matchQueueItemByDomain(delDomain) : undefined);
            }
          },
          [DomainAction.PAUSE_RESTORE_DOMAIN]: () => {
            if (this.handlePauseRestoreResponse(result, domain, 'Deactivated', this.deactivateQueue)) return;
            if (this.handlePauseRestoreResponse(result, domain, 'Running', this.restoreQueue)) return;
            if (!result.data?.row) return;
            if (result.data.error) this.$notification.error({ message: result.data.error });
            else {
              this.refresh();
              this.endSelect();
              bus.$emit('updateDomainStat');
              bus.$emit('updateQuota');
              this.flash(this.$t('domain.SaveSuccess'), 'info', { timeout: 3000 });
            }
          },
          [DomainAction.DOMAIN_UPDATES]: () => {
            const dataMessage = result?.data?.message;
            const dataError = result?.data?.error;
            if (dataMessage) this.flash(dataMessage, 'success', { timeout: 3000 });
            else if (dataError) this.flash(dataError, 'error', { timeout: 3000 });
            const content = dataMessage || dataError;
            if (content) this.showDomainTooltip(domain, content, dataMessage ? 'success' : 'error', 8000);
            if (domain) domain.update(result.data.domain, result.data.domain_meta);
          },
          [DomainAction.CLEAR_CUSTOM_CACHE]: () => {
            if (this.clearCustomCacheQueue?.inFlightCount > 0) {
              this.clearCustomCacheQueue.completeOne();
            }
          },
        };

        const fn = handlers[result.action];
        if (fn) fn();
      };
    },

    /** Format cert_issues error for flash, or return generic message. */
    formatCertIssueError(err) {
      if (!err) return this.$t('message.ErrorCertificateGeneration');
      if (err.cert_issues) {
        const first = err.cert_issues[0] || {};
        return Object.entries(first)
          .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.pop() : v}`)
          .join('; ');
      }
      return err || this.$t('message.ErrorCertificateGeneration');
    },
    /** Returns true if domainName is in the current route list. */
    isDomainOnCurrentPage(domainName) {
      if (!domainName) return false;
      return this.routeList.some((r) => {
        const toCompare = r.getMainHost?.() || r.getName?.()?.replaceAll('-', '.');
        return toCompare === domainName;
      });
    },
    getPendingHosts(row) {
      const hosts = row?.getHosts?.() || [];
      return new Set(hosts);
    },
    resolveMainRowForCertDomain(domainName) {
      if (!domainName) return null;
      return this.routeList.find((row) => {
        const hosts = row?.getHosts?.() || [];
        return hosts.includes(domainName);
      }) || null;
    },
    completeDomainWhenPendingDone(domain, queue, pendingMapKey) {
      if (!domain || !queue) return;
      const domainId = String(this.getDomainId(domain));
      const pendingHosts = this[pendingMapKey][domainId];
      if (pendingHosts && pendingHosts.size > 0) return;
      this.$delete(this[pendingMapKey], domainId);
      queue.completeOne(this.matchQueueItemByDomain(domain));
    },
    handleCertHostResponse({
      domainName,
      message,
      type = 'success',
      hasError = false,
      queue,
      pendingMapKey,
      errorMapKey,
    }) {
      const domain = this.resolveMainRowForCertDomain(domainName);
      if (!domain) return false;

      if (message) {
        this.showDomainTooltip(domain, message, type, 5000);
      }

      const domainId = String(this.getDomainId(domain));
      if (hasError) {
        this.$set(this[errorMapKey], domainId, true);
      }

      const pendingHosts = this[pendingMapKey][domainId];
      if (pendingHosts) {
        pendingHosts.delete(domainName);
      }
      this.completeDomainWhenPendingDone(domain, queue, pendingMapKey);
      return true;
    },
    handleEnableHttpsHostResponse(domainName, message, type = 'success', hasError = false) {
      return this.handleCertHostResponse({
        domainName,
        message,
        type,
        hasError,
        queue: this.enableHttpsQueue,
        pendingMapKey: 'enableHttpsPendingByDomainId',
        errorMapKey: 'enableHttpsHasErrorByDomainId',
      });
    },
    handleForceHttpsHostResponse(domainName, message, type = 'success', hasError = false) {
      const queue = this.getActiveForceHttpsQueue();
      const forceState = this.getForceHttpsStateByQueue(queue);
      if (!queue || !forceState) return false;
      return this.handleCertHostResponse({
        domainName,
        message,
        type,
        hasError,
        queue,
        pendingMapKey: forceState.pendingMapKey,
        errorMapKey: forceState.errorMapKey,
      });
    },
    handleIssueWsError(data) {
      if (!data?.data?.error) return false;
      const err = data.data.error;
      const certAction = data?.action ?? data?.data?.action;

      if (certAction === CertAction.CERT_ISSUE && this.getActiveForceHttpsQueue()?.inFlightCount > 0) {
        const errorMessage = typeof err === 'string' ? err : this.formatCertIssueError(err);
        this.flash(errorMessage, 'error', { timeout: 5000 });
        const domainName = data.data?.domain;
        if (domainName) {
          const handled = this.handleForceHttpsHostResponse(domainName, errorMessage, 'danger', true);
          if (!handled) {
            this.getActiveForceHttpsQueue()?.completeOne(this.matchQueueItemByDomainName(domainName));
          }
        } else {
          const queue = this.getActiveForceHttpsQueue();
          const forceState = this.getForceHttpsStateByQueue(queue);
          if (queue && forceState) {
            queue.inFlightItems.forEach((row) => {
              const id = String(this.getDomainId(row));
              this.$set(this[forceState.errorMapKey], id, true);
            });
            this[forceState.pendingMapKey] = Object.create(null);
            queue.completeAll();
          }
        }
        return true;
      }

      if (this.enableHttpsQueue?.inFlightCount > 0) {
        const errorMessage = typeof err === 'string' ? err : this.formatCertIssueError(err);
        this.flash(errorMessage, 'error', { timeout: 5000 });
        const domainName = data.data?.domain;
        if (domainName) {
          const handled = this.handleEnableHttpsHostResponse(domainName, errorMessage, 'danger', true);
          if (!handled) {
            this.enableHttpsQueue.completeOne(this.matchQueueItemByDomainName(domainName));
          }
        } else {
          this.enableHttpsQueue.inFlightItems.forEach((row) => {
            const id = String(this.getDomainId(row));
            this.$set(this.enableHttpsHasErrorByDomainId, id, true);
          });
          this.enableHttpsPendingByDomainId = Object.create(null);
          this.enableHttpsQueue.completeAll();
        }
        return true;
      }

      if (err?.cert_issues) {
        for (const field in err.cert_issues[0] || {}) {
          const msg = err.cert_issues[0][field]?.pop?.();
          if (msg) this.flash(`${field}: ${msg}`, 'error', { timeout: 3000 });
        }
      } else {
        this.flash(err || this.$t('message.ErrorCertificateGeneration'), 'error', { timeout: 3000 });
      }
      return true;
    },
    handleIssueWsSuccess(data) {
      const domainName = data?.data?.domain;
      const onPage = this.isDomainOnCurrentPage(domainName);
      const certAction = data?.action ?? data?.data?.action;
      const isForceHttpsCertAction = certAction === CertAction.CERT_ISSUE;

      if (isForceHttpsCertAction && this.getActiveForceHttpsQueue()?.inFlightCount > 0) {
        if (data.data?.domain) {
          const message = data.data?.message;
          const handled = this.handleForceHttpsHostResponse(data.data.domain, message, 'success', false);
          if (!handled) {
            this.getActiveForceHttpsQueue()?.completeOne(this.matchQueueItemByDomainName(data.data.domain));
          }
        }
        return;
      }

      const isEnableHttpsAction = data.action === DomainAction.ENABLE_HTTPS;

      if (isEnableHttpsAction && this.enableHttpsQueue?.inFlightCount > 0) {
        if (data.data?.error) {
          this.flash(data.data.error, 'danger', { timeout: 8000 });
          this.enableHttpsQueue.inFlightItems.forEach((row) => {
            const id = String(this.getDomainId(row));
            this.$set(this.enableHttpsHasErrorByDomainId, id, true);
          });
          this.enableHttpsPendingByDomainId = Object.create(null);
          this.enableHttpsQueue.completeAll();
        } else if (data.data?.domain) {
          const message = data.data?.message;
          const handled = this.handleEnableHttpsHostResponse(data.data.domain, message, 'success', false);
          if (!handled) {
            this.enableHttpsQueue.completeOne(this.matchQueueItemByDomainName(data.data.domain));
          }
        }
        return;
      }

      if (isEnableHttpsAction) {
        this.flash(data.data?.message ?? '', 'success', { timeout: 3000 });
        if (onPage) this.refresh();
        this.endSelect();
        return;
      }

      this.flash(this.$t('message.CertificateIssued'), 'success', { timeout: 3000 });
      if (onPage) this.refresh();
    },
    attachIssueWsHandler() {
      this.issue_ws.onMessage = (event, data) => {
        if (!data?.data) return;
        this.sslLoader = false;

        if (this.handleIssueWsError(data)) return;
        this.handleIssueWsSuccess(data);
      };
    },

    closeWs() {
      if (this.domain_ws) this.domain_ws.close();
      if (this.issue_ws) this.issue_ws.close();
    },

    sendDeploy(action, domains) {
      const domainName = (d) => (d && (d.getName ? d.getName() : d.name)) || '';
      const domain_names = domains.map(domainName);
      const resolveDomain = (domain) => this.routeList.find((r) => r.getId() === (domain && domain.getId && domain.getId())) || domain;

      if (action === DomainAction.DOMAIN_DEACTIVATE) {
        domains.forEach((domain) => {
          this.showDomainTooltip(resolveDomain(domain), this.$i18n.t('DeployActionDeactivate'), 'success');
        });
      } else if (action === DomainAction.DOMAIN_RESUME) {
        domains.forEach((domain) => {
          this.showDomainTooltip(resolveDomain(domain), this.$i18n.t('DeployActionResume'), 'success');
        });
      } else if (action === DomainAction.DOMAIN_DELETE) {
        domains.forEach((domain) => {
          this.showDomainTooltip(resolveDomain(domain), this.$i18n.t('DeployActionDelete'), 'success');
        });
      }

      this.domain_ws.sendMessage(action, { domains: domain_names });
    },

    sendIssue(action, domains) {
      const cert_issues = []
      domains.forEach(item => {
        if (item.sslConfig && item.sslConfig.enabled == true) {
          this.showDomainTooltip(item, this.$t('message.SSLAlreadyEnabled'), 'success', 3000)
          this.$set(item, '_patch_status', "done")
          return;
        }
        this.$set(item, '_patch_status', "processing")
        cert_issues.push({
          "cert_type": process.env.NODE_ENV === 'development' ? 'DNS' : 'AUTO',
          "name": item.name,
          "cname": item.cname,
          "model_name": item.model_name ? item.model_name : 'shadowdomain',
          "forceSSL": true
        });
      });

      this.issue_ws.sendMessage(action, {cert_issues: cert_issues})

      return cert_issues.length > 0;
    },

    endSelect() {
      this.patchModal = false;
      // Clear selection with a single reactive write (fast even for 250+ rows).
      this.selectedRowKeyMap = Object.create(null);
    },

    selectAll() {
      const nextMap = Object.create(null);
      this.routeList.forEach((r) => {
        const id = this.getDomainId(r);
        const isLoading =
          this.$store.getters.isDomainActionLoading(id, DomainAction.DOMAIN_DELETE) ||
          this.$store.getters.isDomainActionLoading(id, DomainAction.DOMAIN_DEACTIVATE) ||
          this.$store.getters.isDomainActionLoading(id, DomainAction.DOMAIN_RESUME) ||
          this.$store.getters.isDomainActionLoading(id, DomainAction.CLEAR_CACHE) ||
          this.$store.getters.isDomainActionLoading(id, DomainAction.FORCE_HTTPS) ||
          this.$store.getters.isDomainActionLoading(id, DomainAction.ENABLE_HTTPS);
        if (!isLoading) nextMap[this.getDomainRowKey(r)] = true;
      });
      this.selectedRowKeyMap = nextMap;
    },

    deselectRow(item) {
      const key = this.getDomainRowKey(item);
      if (this.selectedRowKeyMap[key]) this.$delete(this.selectedRowKeyMap, key);
    },

    selectRow(item) {
      const key = this.getDomainRowKey(item);
      if (!this.selectedRowKeyMap[key]) this.$set(this.selectedRowKeyMap, key, true);
    },

    makeDriver() {
      this.driver = new Driver({
        //className: "scoped-class", // className to wrap driver.js popover
        animate: true, // Animate while changing highlighted element
        stageBackground: 'rgba(255, 255, 255, 0.3)',   // This will override the one set in driver
        opacity: 0.1, // Background opacity (0 means only popovers and without overlay)
        padding: 10, // Distance of element from around the edges
        allowClose: true, // Whether clicking on overlay should close or not
        overlayClickNext: false, // Should it move to next step on overlay click
        doneBtnText: this.$t('Done'), // Text on the final button
        closeBtnText: this.$t('Close'), // Text on the close button for this step
        nextBtnText: this.$t('Next'), // Next button text for this step
        prevBtnText: this.$t('Prev'), // Previous button text for this step
        // onHighlightStarted: (Element) => {
        //   this.addDomain() ; // = true;
        // }
        // onNext: (Element) => {
        //   if( Element.node.id == "add-domain" ) {
        //     this.driver.preventMove();
        //     this.driver.moveNext();
        //   }
        // } // Called when element is about to be highlighted
        // Called when moving to next step on any step
      })
    },
    guide() {
      this.makeDriver();
      this.driver.defineSteps([
        {
          element: "#add-domain",
          popover: {
            title: this.$t('guide.TitleAddDomain'),
            description: this.$t('guide.DescriptionAddDomain'),
            position: "left"
          },
          onNext: () => {
            // Prevent moving to the next step
            this.driver.preventMove();

            this.addDomain(); // = true;

            setTimeout(() => {
              this.driver.moveNext();
            }, 100);
          }
        },
        {
          element: "#edit-input-domain",
          popover: {
            title: this.$t('guide.TitleEditDomain'),
            description: this.$t('guide.DescriptionEditDomain'),
            position: "bottom"
          },
        },
        {
          element: "#edit-input-source",
          popover: {
            title: this.$t('guide.TitleEditSource'),
            description: this.$t('guide.DescriptionEditSource'),
            position: "bottom"
          }
        },
        {
          element: "#edit-submit",
          popover: {
            title: this.$t('Save'),
            position: "left"
          },
          onNext: () => {
            // Prevent moving to the next step
            this.driver.preventMove();
            this.editModal = false;
            setTimeout(() => {
              this.driver.moveNext();
            }, 100);
          }
        },
        {
          element: "#display-cname",
          popover: {
            title: this.$t('guide.TitleDisplayCNAME'),
            description: this.$t('guide.DescriptionDisplayCNAME'),
            position: "bottom"
          }
        },
        {
          element: "#member-plans",
          popover: {
            title: this.$t('guide.TitleMemberPlan'),
            description: this.$t('guide.DescriptionMemberPlan'),
            position: "bottom"
          },
          onNext: () => {
            // Prevent moving to the next step
            this.driver.preventMove();
            EventBus.$emit('show-header-dropdown');
            setTimeout(() => {
              this.driver.moveNext();
            }, 100);
          }
        },
        {
          element: "#contact-support",
          popover: {
            title: this.$t('guide.TitleContactSupport'),
            description: this.$t('guide.DescriptionContactSupport'),
            position: 'left-bottom',
          }
        }
      ]);
      this.driver.reset();
      this.driver.start();
    },
    getDefaultDomain() {
      return getDefaultDomainConfig();
    },
    patchSave(domain) {
      //別問我為什麼要這麼寫，我也看不懂。
      (async () => {
        for (const item of this.selectedRows) {
          if (domain.sourceConfig.full_url === MIXED_VALUE) {
            // noop
          } else if (domain.sourceConfig.full_url) {
            item.sourceConfig.full_url = domain.sourceConfig.full_url
          }

          if (domain.sourceConfig.redirect === MIXED_VALUE) {
            // noop
          } else {
            item.sourceConfig.redirect = domain.sourceConfig.redirect;
          }

          if (domain.notes === MIXED_VALUE) {
            // noop
          } else {
            item.notes = domain.notes;
          }

          // domain.strategies is null if the selected domains have different advanced rules.
          // if domain.strategies is null we retain the selected domain advanced rules.
          if (domain.strategies === null) {
            // noop
          } else if (isArray(domain.strategies)) {
            item.strategies = domain.strategies
          } else if (domain._strategies_cleanall) {
            item.strategies = []
          }

          if (domain.cacheConfig.cache_type) {
            item.cacheConfig.cache_type = domain.cacheConfig.cache_type;
            item.cacheConfig.nocache = domain.cacheConfig.nocache || [];
          }

          if (domain.guardConfig) {
            item.guardConfig = {...item.guardConfig, ...domain.guardConfig};
          }

          // promises.push(
          let response = await axios({
            method: "PATCH",
            url: `domain/{domain}/`,
            data: item,
            urlParams: {
              domain: item.name
            }
          }).catch(({errors}) => {
            errors.forEach((message) => {
              this.flash(message, 'error', {"timeout": 5000});
            });
          })
          // response is undefined when the request above failed (the .catch
          // swallowed it); guard so one failure doesn't throw and abort the
          // rest of the batch.
          if (response && response.status === 200) {
            this.flash(item.name + " " + this.$t("domain.SaveSuccess"), "success", {
              timeout: 5000
            });
          }
        }
      })().then(() => {
        this.endSelect();
        this.refresh();
      })
    },
    patchCleancache() {
      if (!this.selectedRows?.length) return;
      if (this.$refs.patchDomainModal) this.$refs.patchDomainModal.processing = true;
      this.selectedRows.forEach((row) => this.setDomainActionLoading(row, DomainAction.CLEAR_CACHE));
      this.clearCacheQueue.enqueueMany(this.selectedRows);
    },
    patchCleanCustomcache(targets) {
      console.log('patchCleanCustomcache', targets, this.$refs.patchDomainModal);
      if (!Array.isArray(targets) || targets.length === 0) return;
      if (this.$refs.patchDomainModal) this.$refs.patchDomainModal.processing = true;
      const chunks = [];
      for (let i = 0; i < targets.length; i += LIMIT_BATCH_CLEAR_CUSTOM_CACHE) {
        chunks.push(targets.slice(i, i + LIMIT_BATCH_CLEAR_CUSTOM_CACHE));
      }
      this.clearCustomCacheQueue.enqueueMany(chunks);
    },
    saveShadow(shadow, domain) {
      let isNew = shadow.id == null;
      axios({
        method: isNew ? "POST" : "PATCH",
        url: isNew
            ? `domain/{domain}/shadow/`
            : `domain/{domain}/shadow/{shadow}/`,
        data: shadow,
        urlParams: {
          domain: domain.name,
          shadow: shadow.name
        }
      }).then(response => {
        shadow = response.data;
        if (response.status == "201") {
          this.flash(this.$t("domain.SaveSuccess"), "success", {
            timeout: 5000
          });
        }
      })
          .catch(({errors}) => {
            errors.forEach((message) => {
              this.flash(message, 'error', {"timeout": 5000});
            });
          });
    },
    closeActivateDomainModal() {
      this.selectedDomain = null;
      this.showConfirmActivateModal = false;
    },
    activateDomain(domain) {
      // Resume = unpause. Route through the working restore queue
      // (PAUSE_RESTORE_DOMAIN, action 9) like the batch path, instead of the
      // raw DOMAIN_RESUME (action 2) which the backend does not handle (AC-2240).
      this.restoreQueue.enqueue(domain);
      this.selectedDomain = null;
      this.showConfirmActivateModal = false;
    },
    getLink(domain) {
      let protocol = "http";
      if (domain.sslConfig && domain.sslConfig.enabled) {
        protocol = "https";
      }
      return `${protocol}://${domain.name}/`;
    },
    doSearch(value) {
      this.domainQ = value;
      this.page = 1;
      this.refresh();
    },
    filterBySearch() {
      const options = {
        includeScore: true,
        useExtendedSearch: true,
        keys: ['hosts', 'serviceHost'],
      };

      const fuse = new Fuse(this.searchData, options, this.searchIndex);
      // Use Fuse's extended search "include-match" match type: https://fusejs.io/examples.html#extended-search
      const result = fuse.search("'" + this.searchTerm)
      this.searchResult = result.map((r) => this.routeMap[r.item.routeId]);
    },
    listenEvent() {
      this.subscribeBus(EventBus, "show-guide", () => this.guide());

      this.subscribeBus(EventBus, [
        Events.SHOW_EDIT_DOMAIN_DIALOG,
        Events.SHOW_EDIT_DOMAIN_DIALOG_SHOW_ADVANCED_CONFIGURATION,
        Events.SHOW_EDIT_DOMAIN_DIALOG_SHOW_SECURITY_SETTING,
      ], (data) => {
        this.selectedDomain = data.domain;
        this.activeModal = MODAL_FLAGS.EDIT;
      });

      this.subscribeBus(EventBus, Events.SHOW_DIAGNOSE_DOMAIN_DIALOG, (data) => this.diagnose(data.domain));
      this.subscribeBus(EventBus, Events.SHOW_APPLY_RULE_DIALOG, (data) => this.applyRule(data.domain));
      this.subscribeBus(EventBus, Events.SHOW_CONFIGURE_SSL_DIALOG, (data) => this.showSslConfig(data.domain));
      this.subscribeBus(EventBus, Events.CLEAR_CACHE_DOMAIN, (data) => this.cleancache(data.domain));
      // Defensive: clear any stale handlers from prior mounts of this component
      // that ran before subscribeBus tracking was in place.
      EventBus.$off(Events.DOWNLOAD_CERTIFICATE);
      this.subscribeBus(EventBus, Events.REPLACE_COMBINE_RULES, () => this.fetchRoutes(this.current_page_offset));
    },

    onChangeQuery(queryParams) {
      this.queryParams = queryParams;
    },
    addDomain() {
      this.selectedDomain = new Route();
      this.activeModal = MODAL_FLAGS.EDIT;
      localStorage.removeItem('blackRules');

    },
    refresh(force = false) {
      const refreshDelay = getRefreshDelay(this.perpage);
      if ((lastExecution + refreshDelay) < Date.now() || force) {
        if (this.cname) {
          this.fetchRoutes(this.current_page_offset);
        }
        this.enableSelect = false;
        // document.getElementsByClassName("custom-control-input")[0].checked = false;
        lastExecution = Date.now()
      }
    },
    editDomain(domain) {
      this.selectedDomain = domain;
      this.activeModal = MODAL_FLAGS.EDIT;
      //this.showDomainTooltip(domain, "errrrrrooorrr", 'success', 8000);
    },
    applyRule(domain) {
      this.selectedDomain = domain;
      this.activeModal = MODAL_FLAGS.APPLY_RULE;
    },
    patchDomain() {
      if (this.selectedRows.length == 0) {
        this.flash(this.$t('message.PleaseCheckTheDomainNameFirst'), "error", {timeout: 3000});
        return
      }
      this.selectedDomain = new Route();
      this.patchModal = false;
      this.patchModal = true;
    },
    /**
     * SSL batch actions apply only to active (non-deactivated) domains.
     * @returns {Route[]} Selected rows excluding deactivated; tooltips/flash for skipped domains.
     */
    filterActiveRowsForSslBatch() {
      const deactivatedRows = this.selectedRows.filter((row) => this.getDomainStatus(row) === 'Deactivated');
      const activeRows = this.selectedRows.filter((row) => this.getDomainStatus(row) !== 'Deactivated');
      if (deactivatedRows.length > 0) {
        deactivatedRows.forEach((row) =>
          this.showDomainTooltip(row, this.$t('message.ssl_config_disabled'), 'info', 8000)
        );
        this.flash(this.$t('message.batch_ssl_skipped_deactivated', { count: deactivatedRows.length }), 'info', {
          timeout: 8000,
        });
      }
      return activeRows;
    },
    patchSSL() {
      if (this.selectedRows.length === 0) return;
      const activeRows = this.filterActiveRowsForSslBatch();
      if (activeRows.length === 0) return;

      const rowsWithCert = activeRows.filter((d) => d?.hasCert?.());
      const rowsWithoutCert = activeRows.filter((d) => !d?.hasCert?.());

      if (rowsWithCert.length > 0) {
        this.flash(this.$t('message.SSLAlreadyEnabledWithCount', { count: rowsWithCert.length }), 'info', { timeout: 5000 });
        rowsWithCert.forEach((row) => this.showDomainTooltip(row, this.$t('message.SSLAlreadyEnabled'), 'info', 5000));
      }

      if (rowsWithoutCert.length > 0) {
        this.sslLoader = true;
        rowsWithoutCert.forEach((row) => this.setDomainActionLoading(row, DomainAction.ENABLE_HTTPS));
        this.enableHttpsQueue.enqueueMany(rowsWithoutCert);
      }
    },
    enableForceSSL() {
      if (this.selectedRows.length === 0) return;
      const activeRows = this.filterActiveRowsForSslBatch();
      if (activeRows.length === 0) return;

      const notHttpsRows = activeRows.filter((d) => !d?.hasCert?.());
      const rowsAlreadyForceHttps = activeRows.filter((d) => d?.hasCert?.() && d?.isForceHttps?.());
      const rowsToEnable = activeRows.filter((d) => d?.hasCert?.() && !d?.isForceHttps?.());

      const skipParts = [];
      if (notHttpsRows.length > 0) {
        skipParts.push(this.$t('message.BatchSelectedDomainsNotHTTPSEnabled', { count: notHttpsRows.length }));
        notHttpsRows.forEach((row) => this.showDomainTooltip(row, this.$t('message.DomainNotHTTPSEnabled'), 'info', 5000));
      }
      if (rowsAlreadyForceHttps.length > 0) {
        skipParts.push(this.$t('message.BatchForceHTTPSNoEnableAction', { count: rowsAlreadyForceHttps.length }));
        rowsAlreadyForceHttps.forEach((row) => this.showDomainTooltip(row, this.$t('message.DomainAlreadyForceHTTPS'), 'info', 5000));
      }
      if (skipParts.length > 0) {
        this.flash(skipParts.join(' '), 'info', { timeout: 5000 });
      }

      if (rowsToEnable.length > 0) {
        rowsToEnable.forEach((row) => this.setDomainActionLoading(row, DomainAction.FORCE_HTTPS));
        this.forceHttpsEnableQueue.enqueueMany(rowsToEnable);
      }
    },
    disableForceSSL() {
      if (this.selectedRows.length === 0) return;
      const activeRows = this.filterActiveRowsForSslBatch();
      if (activeRows.length === 0) return;

      const rowsNotForceHttps = activeRows.filter((d) => !d?.isForceHttps?.());
      const rowsToDisable = activeRows.filter((d) => d?.isForceHttps?.());

      if (rowsNotForceHttps.length > 0) {
        this.flash(this.$t('message.BatchForceHTTPSNoDisableAction', { count: rowsNotForceHttps.length }), 'info', { timeout: 5000 });
        rowsNotForceHttps.forEach((row) => this.showDomainTooltip(row, this.$t('message.DomainAlreadyAllowHTTP'), 'info', 5000));
      }

      if (rowsToDisable.length > 0) {
        rowsToDisable.forEach((row) => this.setDomainActionLoading(row, DomainAction.FORCE_HTTPS));
        this.forceHttpsDisableQueue.enqueueMany(rowsToDisable);
      }
    },
    showSslConfig(domain) {
      // alert('TODO: Feature to be implemented');
      this.selectedDomain = domain;
      this.sslModal = true;
      this.activeModal = MODAL_FLAGS.SSL_CONFIG;
    },
    showClusterUpgrade(domain) {
      this.selectedDomain = domain;
      this.clusterUpgradeModal = true;
    },
    doClearCache() {
      this.clearCacheModal = true;
    },
    diagnose(domain) {
      this.selectedDomain = domain;
      this.diagnoseModal = true;
    },

    async cleancache(domain) {

      let plugins = domain.getPlugins();

      if (!this.isClearCacheEnabled(domain)) {
        this.$notification.info({message: this.$t('ClearCacheActionNotAvailable')});
        return;
        // plugins.push({
        //   name: PLUGIN_NAMES.GAIUS_PROXY_CACHE,
        //   config: {
        //       request_method: ["GET", "HEAD", "OPTIONS"],
        //       response_code: [200, 301, 302],
        //       enable_cache_control: true,
        //       bypass_rules: [],
        //       content_type: ["image", "css", "javascript", "audio", "application"],
        //       cache_version: "1"
        //   },
        //   "enabled": true
        // });
      }

      const newPlugins = plugins.map((p) => {
        if (p['name'] === PLUGIN_NAMES.GAIUS_PROXY_CACHE) {
          const _p = {...p};
          _p.config.cache_version = (_p.config.cache_version || 1) + 1;
          _p.enabled = true;

          return _p;
        }

        return p;
      });

      const newDomain = {...domain.getRawData()};
      newDomain.plugins = newPlugins;

      const payload = {
        domain: newDomain,
        meta: domain.getRawMeta(),
        clear_cache: true
      };

      this.$notification.info({message: this.$t('ClearCacheActionRunning')});

      try {
        await axios({
          method: "PATCH",
          url: `domain/routes/${domain.getId()}/`,
          data: payload,
        });
      } catch (error) {
        this.$notification.error({message: this.$t('ClearCacheActionFailed')});
        return;
      }

      this.refresh(true);

      setTimeout(() => {
        this.$notification.success({message: this.$t('ClearCacheActionSuccessful')});
      }, 1000);


    },

    isClearCacheEnabled(domain) {
      const plugins = domain.getPlugins();

      for (let p of plugins) {
        if (p['name'] === PLUGIN_NAMES.GAIUS_PROXY_CACHE && p['enabled'] == true) {
          return true;
        }
      }

      return false;
    },
    fetchRoutes() {
      this.listLoading = true;
      // discard responses from superseded calls — pagination, the filter
      // handlers, search and WS-driven refreshes can all overlap.
      const seq = this._fetchRoutesSeq = (this._fetchRoutesSeq || 0) + 1;
      let searchDomains = [];
      for (let d of this.selectedSearchDomains) {
        searchDomains.push(d.name);
      }
      if (this.findMultiDomain) {        
        let findMultipleDomain = this.findMultiDomain.toLowerCase();
        findMultipleDomain = findMultipleDomain.split('\n');
        for (let i in findMultipleDomain) {
          const findDomainQ = findMultipleDomain[i].trim();
          if (findDomainQ == "") {
            continue;
          }
          if (findDomainQ.includes(' ')) {
            this.notifyError(this.$t('message.InvalidDomain',[findMultipleDomain[i]]));
            return;
          }
          searchDomains.push(findDomainQ);
        }
        searchDomains = [...new Set(searchDomains)];
      }
      if (this.findBtnClicked) {
        this.visibleModalFindDomain = !this.visibleModalFindDomain;
        this.findBtnClicked = false;
      }

      if (this.domainQ !== null && this.domainQ.length > 0) {        
        this.domainQ = this.domainQ.trim();
      }

      const params = {
        page: this.page,
        perpage: this.perpage,
        cert_status: this.certStatus,
        status: this.domainStatus,
        sort_by: this.sortBy,
      }

      const payload = {
        q: this.domainQ,
        q1: searchDomains.join(","),
      }

      return findDomains(payload, params)
        .then((response) => {
          if (seq !== this._fetchRoutesSeq) return;
          const responseData = response.data;

          this.routes = makeRoutes(responseData.domains);
          this.total_pages = responseData.total_pages;
          this.total_rows = responseData.domains.length;
          this.total_items = this.total_pages * this.perpage;

          if ((this.domainQ !== null && this.domainQ.length > 0) || searchDomains.length > 0) {
            this.count = true;
          } else {
            this.count = false;
          }
        })
        .catch(({errors}) => {
          if (seq !== this._fetchRoutesSeq) return;
          (errors || []).forEach((message) => this.notifyError(message));
        })
        .finally(() => {
          if (seq !== this._fetchRoutesSeq) return;
          this.listLoading = false;
          this.endSelect();
        });
    },
    handleHideSslConfig() {
      this.endSelect();
      this.sslModal = false;
      this.activeModal = null;
      this.refresh();
      this.attachIssueWsHandler();
    },
    doDiagnoseCheck() {
      if (this.selectedRows.length == 0) {
        this.flash(this.$t('message.PleaseCheckTheDomainNameFirst'), "error", {timeout: 3000});
        return;
      }

      this.showSummaryDiagnoseModal = true;
    },
    patchActive() {
      if (this.selectedRows.length == 0) {
        this.flash(this.$t('message.PleaseCheckTheDomainNameFirst'), "error", {timeout: 3000});
        return;
      }
      const toRestore = this.selectedRows.filter((row) => this.getDomainStatus(row) === 'Deactivated');
      const skipped = this.selectedRows.filter((row) => this.getDomainStatus(row) === 'Running')
      if (toRestore.length === 0) {
        this.flash(this.$t('message.batch_restore_already_active'), "info", {timeout: 4000});
        return;
      }
      Modal.confirm({
        title: this.$t('message.ConfirmDomainsActive'),
        onOk: () => {
          if (this.$refs.patchDomainModal) this.$refs.patchDomainModal.processing = true;
          toRestore.forEach((row) => this.setDomainActionLoading(row, DomainAction.DOMAIN_RESUME));
          this.restoreQueue.enqueueMany(toRestore);
          if (skipped.length > 0) {
            skipped.forEach((row) => this.showDomainTooltip(row, this.$t('message.domain_already_active'), 'info', 4000));
            this.flash(this.$t('message.batch_restore_skipped', { count: skipped.length }), "info", { timeout: 4000 });
          }
        },
      });
    },
    patchDeactive() {
      if (this.selectedRows.length == 0) {
        this.flash(this.$t('message.PleaseCheckTheDomainNameFirst'), "error", {timeout: 3000});
        return;
      }
      const toDeactivate = this.selectedRows.filter((row) => this.getDomainStatus(row) === 'Running');
      const skipped = this.selectedRows.filter((row) => this.getDomainStatus(row) === 'Deactivated');
      if (toDeactivate.length === 0) {
        this.flash(this.$t('message.batch_deactivate_already_deactivated'), "info", { timeout: 4000 });
        return;
      }
      Modal.confirm({
        title: this.$t('message.ConfirmDomainsDeactive'),
        onOk: () => {
          if (this.$refs.patchDomainModal) this.$refs.patchDomainModal.processing = true;
          toDeactivate.forEach((row) => this.setDomainActionLoading(row, DomainAction.DOMAIN_DEACTIVATE));
          this.deactivateQueue.enqueueMany(toDeactivate);
          if (skipped.length > 0) {
            skipped.forEach((row) => this.showDomainTooltip(row, this.$t('message.domain_already_deactivated'), 'info', 4000));
            this.flash(this.$t('message.batch_deactivate_skipped', { count: skipped.length }), "info", { timeout: 4000 });
          }
        },
      });
    },
    batchDelete() {
      if (this.isBatchDeleteInProgress) return;
      const deletableRows = this.selectedRows.filter((row) => {
        const tags = row._data.tags;
        return tags && tags.find((t) => t.includes('cname'));
      });
      if (deletableRows.length === 0) {
        return;
      }
      if (this.$refs.patchDomainModal) this.$refs.patchDomainModal.processing = true;
      // Mark all selected deletable rows as "deleting" (including queued-but-not-yet-sent).
      deletableRows.forEach((row) => this.setDomainActionLoading(row, DomainAction.DOMAIN_DELETE));
      this.deleteQueue.enqueueMany(deletableRows);
    },

    async exportAllDomain() {
      this.setExportImportLang();
      this.flash(this.$t('message.DownloadStarted'), 'info', {"timeout": 3000});
      const body_domains = this.selectedRows.map((sr) => sr._data.domain_name);
      let domains = await axios({
        method: "POST",
        url: `domain/download/`,
        data: {
          domains: body_domains,
          page: this.page,
          perpage: this.perpage,
        }
      })
      const data = domains.data.domains;
      const download_data = [];
      data.forEach(item => {
        let status = item.domain.status;
        switch (item.domain.status) {
          case "Running":
            status = "Online";
            break;
          case "Deactivated":
            status = "Disabled";
            break;
        }

        if (item.domain.domain_action == "redirect") {
          const plugins = item.domain.plugins;
          plugins.forEach(plugin => {
            if (plugin.name === 'gaius-redirect') {
              const plugin_data = plugin.config.redirect_url;
              download_data.push({
                [COLUMN_KEYS.NAME]: item.domain.hosts[0],
                [COLUMN_KEYS.ORIGIN_IP]: plugin_data,
                [COLUMN_KEYS.PROTOCOL]: item.domain.service.protocol,
                [COLUMN_KEYS.SHADOW_DOMAINS]: item.domain.hosts.slice(1, item.domain.hosts.length).join(', '),
                [COLUMN_KEYS.STATUS]: status,
                [COLUMN_KEYS.AUTO_GENERATE_CERT]: item.domain.service.tags.includes(TAG_NAMES.HAS_AUTO_GENERATE_CERTIFICATE),
                [COLUMN_KEYS.REMARK]: item.meta.description,
              })
            }
          })
        } else {
          download_data.push({
            [COLUMN_KEYS.NAME]: item.domain.hosts[0],
            [COLUMN_KEYS.ORIGIN_IP]: item.domain.upstream.targets.map((sr) => sr.target).join(', '),
            [COLUMN_KEYS.PROTOCOL]: item.domain.service.protocol,
            [COLUMN_KEYS.SHADOW_DOMAINS]: item.domain.hosts.slice(1, item.domain.hosts.length).join(', '),
            [COLUMN_KEYS.STATUS]: status,
            [COLUMN_KEYS.AUTO_GENERATE_CERT]: item.domain.service.tags.includes(TAG_NAMES.HAS_AUTO_GENERATE_CERTIFICATE),
            [COLUMN_KEYS.REMARK]: item.meta.description,
          })
        }

      });
      await this._exportDomainData(download_data);
      this.endSelect();
      this.flash(this.$t("message.DownloadCompleted"), 'success', {"timeout": 3000});
    },
    getRoutes(serviceId) {
      return this.routeMap[serviceId].hosts;
    },
    handleGoToOldDomainUI() {
      if (window.localStorage) {
        window.localStorage.setItem('OPT_OUT_NEW_DOMAIN_UI', 'true');
      }
      this.$router.push({path: '/domain/list0'});
    },
    handleConfigureCnameClick() {
      this.activeModal = MODAL_FLAGS.CONFIGURE_CNAME;
    },
    onOpenConfigureDomain() {
      if(!this.isFreeCname) {
        this.activeTab = CONFIGURE_CNAME_TABS.UPGRADE;
      }
      this.handleConfigureCnameClick();
    },
    closeConfigureCnameModal() {
      this.activeModal = null;
      this.activeTab = CONFIGURE_CNAME_TABS.DOMAIN;
    },
    handleExpandedCreateButton(e) {
      if (e.key === 'import') {
        router.push({path: '/domain/import'})
      } else if (e.key === 'create-rules') {
        router.push({path: '/domain/rules'})
      }
    },
    handleExpandedBatchEditButton(e) {
      if (e.key === 'clear-cache') {
        this.doClearCache();
      } else if (e.key === 'diagnose') {
        this.doDiagnoseCheck();
      } else if (e.key === 'enable-https') {
        this.patchSSL();
      } else if (e.key === 'enable-force-https') {
        this.enableForceSSL();
      } else if (e.key === 'disable-force-https') {
        this.disableForceSSL();
      } else if (e.key === 'status-restore') {
        this.patchActive();
      } else if (e.key === 'status-deactivate') {
        this.patchDeactive();
      } else if (e.key === 'status-delete') {
        const me = this;

        Modal.confirm({
          title: this.$t('message.ConfirmBatchDomainDelete'),
          onOk() {
            me.batchDelete();
          },
        });
      } else if (e.key === 'download') {
        this.exportAllDomain();
      }
    },
    handleDomainStatusFilter(filter) {
      this.domainStatus = filter === 'all' ? '' : filter;
      this.refresh(true);
    },
    handleCertStatusFilter(filter) {
      this.certStatus = filter === 'all' ? '' : filter;
      this.refresh(true);
    },
    handleSortByFilter(sortBy) {
      this.sortBy = sortBy;
      this.refresh(true);
    },
    handleDomainSelect({ domain, selected }) {
      if (selected) {
        this.selectRow(domain);
      } else {
        this.deselectRow(domain);
      }
    },
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.searchInput .form-control {
  height: 43px !important;
}

.multiselect-search {
  top: 5px;
}

.filter-controls .multiselect__content .load-more {
  font-size: 0.9em;
  margin-left: 12px;
  color: #39f;
  cursor: pointer;
}

.filter-controls .multiselect__content .load-more:hover {
  text-decoration: underline;
}

.GrayLock {
  color: gray;
}

.GreenLock {
  color: green;
}

.source-config-value {
  display: flex;
  align-items: center;
}

.source-config-value span {
  padding-left: 6px;
}

.domain-notes {
  white-space: nowrap;
  width: 100%; /* IE6 needs any width */
  overflow: hidden; /* "overflow" value must be different from  visible"*/
  -o-text-overflow: ellipsis; /* Opera < 11*/
  text-overflow: ellipsis; /* IE, Safari (WebKit), Opera >= 11, FF > 6 */
}

#filterBox {
  position: relative;
  margin-bottom: 10px;
  width: 100%;
  display: none;
}

#filterBox.Show {
  display: flex !important;
}
</style>

<style lang="scss">
.root-domain-message-warning-icon {
  font-size: 42px;
}

.opacity-0 {
  opacity: 0;
}

.domain-list-container .ant-list-items .ant-list-item:first-child {
  padding-top: 0;
  overflow: hidden;
}

.multiselect .multiselect__tags {
  padding: 5px 40px 0 8px;
  border: 1px solid #d9d9d9;
}

.searchInput .ant-input::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  font-size: 0.9em;
}

.searchInput .ant-input::-moz-placeholder { /* Firefox 19+ */
  font-size: 0.9em;
}

.searchInput .ant-input:-ms-input-placeholder { /* IE 10+ */
  font-size: 0.9em;
}

.searchInput .ant-input:-moz-placeholder { /* Firefox 18- */
  font-size: 0.9em;
}

.popover-list-filter-trigger.btn svg {
  height: 20px;
  width: 20px;
}

.exclusive-cname {
  i {
    top: 50%;
    transform: translateY(-50%);
  }
}

.create-button-group .ant-btn-default {
  background-color: #00affe;
  color: white;
  border-color: #00a2eb;
}
</style>
